import axios from "axios";
import authHeader from "./auth-header";

export default function createInstance(config = null) {
  config
    ? (config["headers"] = authHeader())
    : (config = { headers: authHeader() });

  const instance = axios.create(config);

  // Intercepta o response e verifica o código de status retornado no erro.
  instance.interceptors.response.use(
    (response) => {
      localStorage.removeItem("maintenance");
      return response;
    },
    async (error) => {
      if (error.response.data.constructor.name === "Blob") {
        // Retorna um JSON com a mensagem de erro para request com responseType igual a Blob
        return JSON.parse(await error.response.data.text());
      } else if (
        error.response.status === 401 &&
        error.response.data.code === 2
      ) {
        /**
         * Usuário não autorizado. HTTP CODE 401
         * */
        // Verifica se os códigos correspodem a "Unauthorized"
        alert("Token expirado. Logue novamente.");
        // Apaga os dados do localStorage
        localStorage.clear();
        // Recarrega a página
        history.go(0);
      } else if (error.response.status === 423) {
        /**
         * Servidor em manutenção. HTTP CODE 503 OR 423
         * */
        const path = window.location.pathname;
        localStorage.clear();
        // Atualizando status do site para manutenção
        localStorage.setItem("maintenance", "true");
        // Redireciona para a página de manutenção
        if (path !== "/maintenance") window.location.href = "/maintenance";
      }

      return error.response;
    }
  );

  return instance;
}
